const STORAGE_KEY = 'pm-active-tab'

export default class extends HTMLElement {
  connectedCallback () {
    const buttons = this.querySelectorAll('.pm-tab-btn')
    const panels = this.querySelectorAll('.pm-tab-panel')

    const activate = (tab) => {
      buttons.forEach((b) => b.classList.toggle('active', b.dataset.tab === tab))
      panels.forEach((p) => p.classList.toggle('active', p.dataset.tabPanel === tab))
      try { localStorage.setItem(STORAGE_KEY, tab) } catch { /* stockage indisponible, tant pis */ }
    }

    buttons.forEach((btn) => btn.addEventListener('click', () => activate(btn.dataset.tab)))

    let saved = null
    try { saved = localStorage.getItem(STORAGE_KEY) } catch { /* ignore */ }
    if (saved && this.querySelector('.pm-tab-panel[data-tab-panel="' + saved + '"]')) {
      activate(saved)
    }
  }
}
